import axios from 'axios'
import SessionStorage from './SessionStorage'

export const API_ROOT = '/api/v1';

const API = axios.create({
  baseURL: API_ROOT,
  timeout: 60000
});

function getRequestURL(url, dynamicSegments) {
  if (!dynamicSegments) {
    dynamicSegments = {};
  }

  return url
    .split('/')
    .map(segment => {
      if (segment[0] === ':') {
        const segmentKey = segment.slice(1);
        const value = dynamicSegments[segmentKey];

        if (process.env.NODE_ENV !== 'production') {
          if (typeof value === 'undefined' || value === null) {
            throw new Error(`Failed replace segment ":${segmentKey}". Missing value in dynamicSegments`);
          }
        }

        return value;
      }

      return segment
    })
    .join('/');
}

function request(name, dynamicSegments, method, data, config) {
  const url = getRequestURL(name, dynamicSegments);

  return API
    .request({
      ...config,
      method,
      url,
      data,
      params: {
        ...(config ? config.params || {} : {}),
        _: SessionStorage.get()
      }
    })
    .then(res => res.data);
}

const Api = {
  get: (name, dyn, config) => request(name, dyn, 'GET', null, config),
  delete: (name, dyn, config) => request(name, dyn, 'DELETE', null, config),
  head: (name, dyn, config) => request(name, dyn, 'HEAD', null, config),
  post: (name, dyn, data, config) => request(name, dyn, 'POST', data, config),
  put: (name, dyn, data, config) => request(name, dyn, 'PUT', data, config),
  patch: (name, dyn, data, config) => request(name, dyn, 'PATCH', data, config)
}

export default Api
